module.exports = __webpack_public_path__ + "img/pdf.a4fbc160.png";